import React, { useEffect, useState } from "react";
import {
  addGaonService,
  getGaonServiceById,
  getGaonServices,
  putGaonService,
  removeGaonService,
} from "../../action/gaonApi";
import uploadImage from "../../action/imageUpload";
import { getImageUrl } from "../../helper/constants";
import { Button, Modal } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import ThumbnailPicker from "../../components/ThumbnailPicker/ThumbnailPicker";
import trashIcon from "../../assets/images/trash-03.svg";
import editIcon from "../../assets/images/edit_btn.svg";
import showNotification from "../../components/notification/showNotification";
import Form from "react-bootstrap/Form";
import { useFormik } from "formik";

const BrowseService = ({ id }) => {
  const [gaonServices, setGaonServices] = useState([]);
  const [editCanvas, setShowEditCanvas] = useState(false);
  const [serviceId, setServiceId] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const addGaonServiceFormik = useFormik({
    initialValues: {
      name: "",
      gaonId: "",
      assets: {
        url: "",
        type: 2,
        h: 0,
        w: 0,
      },
    },
    onSubmit: async (values) => {
      try {
        if (values.assets.url == "") {
          showNotification("Gaon Browse Services", "Select Image", "danger");
          return;
        }
        values.gaonId = id;
        const res = await addGaonService(values);
        if (res.status) {
          setShowForm(false);
          fetchGaonServices();
          showNotification("Gaon Browse Services", res?.message, "success");
          addGaonServiceFormik.handleReset();
        } else {
          showNotification(
            "Gaon Browse Services",
            res.message ? res.message : res,
            "danger"
          );
        }
      } catch (error) {
        console.error("Failed to add category", error);
      }
    },
  });

  const fetchGaonServices = async () => {
    const res = await getGaonServices(id);
    if (res.status) {
      setGaonServices(res.data?.list);
    }
  };

  const fetchGaonServiceById = async (id) => {
    const res = await getGaonServiceById(id);
    if (res.status) {
      editGaonServiceFormik.setFieldValue("name", res.data?.name);
      editGaonServiceFormik.setFieldValue("assets", res.data?.assets);
    }
  };

  const editGaonServiceFormik = useFormik({
    initialValues: {
      name: "",
      gaonId: "",
      assets: {
        url: "",
        type: 2,
        h: 0,
        w: 0,
      },
    },
    onSubmit: async (values) => {
      try {
        if (values.assets.url == "") {
          showNotification("Gaon Browse Services", "Select Image", "danger");
          return;
        }
        values.gaonId = id;
        const res = await putGaonService(serviceId, values);
        if (res.status) {
          setShowEditCanvas(false);
          fetchGaonServices();
          showNotification("Gaon Browse Services", res?.message, "success");
          editGaonServiceFormik.handleReset();
        } else {
          showNotification(
            "Gaon Browse Services",
            res.message ? res.message : res,
            "danger"
          );
        }
      } catch (error) {
        console.error("Failed to add category", error);
      }
    },
  });

  const deleteGaonService = async () => {
    const res = await removeGaonService(serviceId);
    if (res.status) {
      showNotification("Gaon Browse Services", res?.message, "success");
      fetchGaonServices();
      setShowDeleteModal(false);
    }
  };

  const uploadMediaImage = async (file, type) => {
    const formData = new FormData();
    formData.append("file", file);
    const res = await uploadImage(formData, "service");
    if (res.status) {
      if (type == 1)
        addGaonServiceFormik.setFieldValue("assets.url", res.data[0]);
      else editGaonServiceFormik.setFieldValue("assets.url", res.data[0]);
    }
  };

  useEffect(() => {
    fetchGaonServices();
  }, []);

  return (
    <div className="payout_data-content tablePage_content_header mt-3 mb-3">
      <div className="address_section">
        <div className="address_div">
          <div className="address_label">
            <h4>Browse Services</h4>
            <div>
              <Button variant="primary" onClick={() => setShowForm(true)}>
                Add Service
              </Button>
            </div>
          </div>

          <div className="address_option">
            <table className="payout_table upi-mandate_table">
              <thead>
                <tr className="tableHead">
                  <th className="thHeader">Image</th>
                  <th className="thHeader">Name</th>
                  <th className="thHeader">Action</th>
                </tr>
              </thead>
              <tbody>
                {gaonServices && gaonServices.length > 0 ? (
                  gaonServices.map((service) => (
                    <tr key={service._id}>
                      <td>
                        {service?.assets?.url && (
                          <img
                            src={getImageUrl(service?.assets?.url)}
                            alt={service?.name}
                            style={{
                              width: "50px",
                              height: "50px",
                              objectFit: "cover",
                            }}
                          />
                        )}
                      </td>
                      <td>{service?.name}</td>
                      <td>
                        <button
                          className="action_btn1"
                          onClick={() => {
                            fetchGaonServiceById(service?._id);
                            setServiceId(service?._id);
                            setShowEditCanvas(true);
                          }}
                        >
                          <img src={editIcon} alt="edit" />
                        </button>
                        <button
                          className="action_btn1"
                          onClick={() => {
                            setServiceId(service?._id);
                            setShowDeleteModal(true);
                          }}
                        >
                          <img src={trashIcon} alt="delete" />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <>
                    <tr>
                      <td colspan="11" className="text_center">
                        No data found
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>
          {/* OffCanvas Form */}
          <Offcanvas
            show={showForm}
            onHide={() => {
              addGaonServiceFormik.handleReset();
              setShowForm(false);
            }}
            placement="end"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Add New Service</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <div className="px-3">
                <Form onSubmit={addGaonServiceFormik.handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Service Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={addGaonServiceFormik.values.name}
                      onChange={addGaonServiceFormik.handleChange}
                      onBlur={addGaonServiceFormik.handleBlur}
                      isInvalid={
                        addGaonServiceFormik.touched.name &&
                        addGaonServiceFormik.errors.name
                      }
                      placeholder="Enter product name"
                    />
                    <Form.Control.Feedback type="invalid">
                      {addGaonServiceFormik.errors.name}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Product Image</Form.Label>
                    <ThumbnailPicker
                      width="auto"
                      height="250px"
                      onFileSelect={(file) => {
                        const _URL = window.URL || window.webkitURL;

                        const img = new Image();
                        uploadMediaImage(file, 1);

                        img.src = _URL.createObjectURL(file);
                      }}
                      image={addGaonServiceFormik.values?.assets?.url}
                      accept={"image/*"}
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    className="btn btn-success"
                  >
                    Add Product
                  </Button>
                </Form>
              </div>
            </Offcanvas.Body>
          </Offcanvas>

          {/* OffCanvas Edit Service Form */}
          <Offcanvas
            show={editCanvas}
            onHide={() => {
              editGaonServiceFormik.handleReset();
              setShowEditCanvas(false);
            }}
            placement="end"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Add New Service</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <div className="px-3">
                <Form onSubmit={editGaonServiceFormik.handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Service Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={editGaonServiceFormik.values.name}
                      onChange={editGaonServiceFormik.handleChange}
                      onBlur={editGaonServiceFormik.handleBlur}
                      isInvalid={
                        editGaonServiceFormik.touched.name &&
                        editGaonServiceFormik.errors.name
                      }
                      placeholder="Enter product name"
                    />
                    <Form.Control.Feedback type="invalid">
                      {editGaonServiceFormik.errors.name}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Product Image</Form.Label>
                    <ThumbnailPicker
                      width="auto"
                      height="250px"
                      onFileSelect={(file) => {
                        const _URL = window.URL || window.webkitURL;

                        const img = new Image();
                        uploadMediaImage(file, 1);

                        img.src = _URL.createObjectURL(file);
                      }}
                      image={editGaonServiceFormik.values?.assets?.url}
                      accept={"image/*"}
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    className="btn btn-success"
                  >
                    Save
                  </Button>
                </Form>
              </div>
            </Offcanvas.Body>
          </Offcanvas>

          {/* Delete Confirmation Modal */}
          <Modal
            show={showDeleteModal}
            onHide={() => setShowDeleteModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to delete the service</Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="danger"
                className="btn btn-dark"
                onClick={() => {
                  deleteGaonService();
                }}
              >
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default BrowseService;
